export const TEXT_OPEN_POD_DIALOG =
  'Launch the MSP Process Pod to perform End-user Verification, securely send files, and more!';

export const TEXT_OPEN_POD_SECURE_DATA = 'Secure Data';

export const getPodDisabledTooltip = (constactFieldName = 'Contact') =>
  `This option is disabled because this ticket doesn’t have an assigned ${constactFieldName}.`;

export default {};
